/* Central Coast Coffee — shared glossary behaviour (flip + search + group/category filter).
 * Powers snippets/coffee-glossary.liquid on BOTH the standalone /pages/coffee-glossary page
 * and the Coffee School page. Self-contained; no dependency on coffee-lingo.js.
 * Progressive enhancement: the glossary reads fine (all definitions server-rendered) without it. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRoot(root) {
    if (root.dataset.glossReady === '1') return;
    root.dataset.glossReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.lingo-gcard'));
    var items = cards.map(function (card) {
      return { card: card, text: card.textContent.toLowerCase(), cat: card.getAttribute('data-cat') || '', group: card.getAttribute('data-group') || '' };
    });

    // flip
    cards.forEach(function (card) {
      var btn = card.querySelector('.lingo-gcard__btn');
      var front = card.querySelector('.lingo-gcard__front');
      var back = card.querySelector('.lingo-gcard__back');
      var face = function (flipped) {
        if (front) front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
        if (back) back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
      };
      face(false);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var flipped = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        face(flipped);
      });
    });

    var search = root.querySelector('[data-gloss-search]');
    var groupChips = Array.prototype.slice.call(root.querySelectorAll('[data-gloss-group]'));
    var catChips = Array.prototype.slice.call(root.querySelectorAll('[data-gloss-cat]'));
    var empty = root.querySelector('[data-gloss-empty]');
    var count = root.querySelector('[data-gl-count]');
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-gl-group]'));
    var group = 'all', cat = 'all', query = '', t = 0;

    function setPressed(list, active) {
      list.forEach(function (c) {
        var on = c === active;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function apply() {
      var shown = 0;
      items.forEach(function (it) {
        var ok = (group === 'all' || it.group === group) &&
                 (cat === 'all' || it.cat === cat) &&
                 (!query || it.text.indexOf(query) !== -1);
        it.card.hidden = !ok;
        if (ok) shown += 1;
      });
      // hide a group section whose cards are all filtered out
      sections.forEach(function (sec) {
        var any = sec.querySelectorAll('.lingo-gcard:not([hidden])').length > 0;
        sec.hidden = !any;
      });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown === items.length
        ? (items.length + ' terms')
        : (shown + ' of ' + items.length + ' terms');
    }

    if (search) {
      search.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { query = search.value.trim().toLowerCase(); apply(); }, reduce ? 0 : 110);
      });
    }
    groupChips.forEach(function (chip) {
      chip.addEventListener('click', function () { setPressed(groupChips, chip); group = chip.getAttribute('data-gloss-group'); apply(); });
    });
    catChips.forEach(function (chip) {
      chip.addEventListener('click', function () { setPressed(catChips, chip); cat = chip.getAttribute('data-gloss-cat'); apply(); });
    });
    apply();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-coffee-glossary]')).forEach(initRoot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
